module.exports = __webpack_public_path__ + "img/qr.c892ee40.jpg";